import { KYMW1102SearchResultModel } from '../vo/kymw1102-search-result.model';
import { PlessResponder } from '../../../../shared/http/pless-responder.service';
import { KYMW1102Model } from '../kymw1102.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ファイル出力クラス
 *
 * @export SaveFileService
 * @class SaveFileService
 * @extends {PlessResponder}
 */
@Injectable()
export class SaveFileService extends PlessJsonResponderSub<any> {

  // VO
  private vo: KYMW1102SearchResultModel = new KYMW1102SearchResultModel;
  // 処理に使用するModel
  private model: KYMW1102Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof SaveFileService
   */
  private getBody(): PlessRequest {
    const pCodes = this.vo.PCodes.map((pCode, i) => ({
      condition: {
        PCodes: pCode,
        ClassDivNums: this.vo.ClassDivNums[i],
        ClassCodes: this.vo.ClassCodes[i],
        MiddleClassCodes: this.vo.MiddleClassCodes[i],
        SmallClassCodes: this.vo.SmallClassCodes[i],
        GuideGoodsNames: this.vo.GuideGoodsNames[i],
        GuideStandardNames: this.vo.GuideStandardNames[i],
        ConsumeTerms: this.vo.ConsumeTerms[i],
        ConsymeByDates: this.vo.ConsymeByDates[i],
        SetDivs: this.vo.SetDivs[i],
        LongKeepDivs: this.vo.LongKeepDivs[i],
        AssortTempDivs: this.vo.AssortTempDivs[i],
        ItemCodes: this.vo.ItemCodes[i],
        JanCodes: this.vo.JanCodes[i],
        BrandTypes: this.vo.BrandTypes[i],
        OrderClientCodes: this.vo.OrderClientCodes[i],
        MakerNames: this.vo.MakerNames[i],
        EbaseSpecCodes: this.vo.EbaseSpecCodes[i],
        PeaceSizeLengths: this.vo.PeaceSizeLengths[i],
        PeaceSizeWidths: this.vo.PeaceSizeWidths[i],
        PeaceSizeHeights: this.vo.PeaceSizeHeights[i],
        CaseSizeLengths: this.vo.CaseSizeLengths[i],
        CaseSizeWidths: this.vo.CaseSizeWidths[i],
        CaseSizeHeights: this.vo.CaseSizeHeights[i],
        RegistCatalogRounds: this.vo.RegistCatalogRounds[i],
        ClassNameKanjis: this.vo.ClassNameKanjis[i],
        MiddleClassNameKanjis: this.vo.MiddleClassNameKanjis[i],
        SmallClassNameKanjis: this.vo.SmallClassNameKanjis[i],
        SupplyPriceStandards: this.vo.SupplyPriceStandards[i],
        SupplyPriceSpecial1s: this.vo.SupplyPriceSpecial1s[i],
        SupplyPriceSpecial2s: this.vo.SupplyPriceSpecial2s[i],
        SupplyTaxWithoutStds: this.vo.SupplyTaxWithoutStds[i],
        SupplyTaxWithoutSpc1s: this.vo.SupplyTaxWithoutSpc1s[i],
        SupplyTaxWithoutSpc2s: this.vo.SupplyTaxWithoutSpc2s[i],
        CostPriceStandards: this.vo.CostPriceStandards[i],
        CostPriceSpecial1s: this.vo.CostPriceSpecial1s[i],
        CostPriceSpecial2s: this.vo.CostPriceSpecial2s[i],
        BrandTypeNames: this.vo.BrandTypeNames[i],
        AssortTempDivNames: this.vo.AssortTempDivNames[i],
        SetDivNames: this.vo.SetDivNames[i],
        LongkeepDivNames: this.vo.LongkeepDivNames[i],
        OrderClientNames: this.vo.OrderClientNames[i],
        ProjectMonths: this.vo.proMonths[i],
        ProjectKais: this.vo.proKais[i],
        PointPlans: this.vo.pointPlans[i],
        SupplyPlans: this.vo.supplyPlans[i],
        ConsumeTaxDivs: this.vo.ConsumeTaxDivs[i],
        ConsumeTaxRates: this.vo.ConsumeTaxRates[i]
      }
    }));
    return new PlessRequest({
      regist: {
        SaveDataMaster: {
          condition: {
            OutputYear: this.vo.outputYear,
            OutputMonth: this.vo.outputMonth,
            OutputKai: this.vo.outputKai,
            OutputChargePerson: this.vo.outputChargePerson
          },
          combination: pCodes
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model 処理に使用するモデル
   * @param vo vo
   * @param successFunc 成功時に実行される処理
   * @memberof SaveFileService
   */
  execute(model: KYMW1102Model, vo: KYMW1102SearchResultModel, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('save3File', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof SaveFileService
   */
  success(data: any): void {

    // レスポンスのファイルパスをマネージに保存
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
